import { Anchor } from '@mantine/core'

export default function Footer() {
  const handleScrollToDisclaimer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    const element = document.getElementById('disclaimer')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <footer className="bg-gray-900">
      <div className="max-w-5xl mx-auto px-6 py-10">
        <div className="flex flex-col items-center text-center">
          <span className="text-lg font-semibold text-white mb-2">优查查</span>
          <p className="text-sm text-gray-400 mb-6">个人与企业信息查询平台</p>

          <div className="flex items-center gap-6 text-sm mb-8">
            <Anchor
              href="#disclaimer"
              onClick={handleScrollToDisclaimer}
              className="text-gray-400 hover:text-white transition-colors"
            >
              使用说明
            </Anchor>
            <span className="text-gray-700">·</span>
            <Anchor href="privacyPolicy.html" className="text-gray-400 hover:text-white transition-colors">
              隐私政策
            </Anchor>
            <span className="text-gray-700">·</span>
            <Anchor href="userAgreement.html" className="text-gray-400 hover:text-white transition-colors">
              服务条款
            </Anchor>
          </div>

          <div className="text-xs text-gray-500 space-y-1">
            <p>© 2024 四川捷创优信科技有限公司</p>
            <Anchor
              href="https://beian.miit.gov.cn/"
              target="_blank"
              className="text-gray-500 hover:text-gray-400 transition-colors"
            >
              蜀ICP备2024054454号
            </Anchor>
          </div>
        </div>
      </div>
    </footer>
  )
}
